const MIN_PEAK_VALUE = -128;
const MAX_PEAK_VALUE = 127;

class PeaksDataHeader {
  version = 0;

  is8bit = false;

  sampleRate = 0;

  scale = 0.01;

  numSamples = 0;

  static fromView(view) {
    const header = new PeaksDataHeader();
    header.version = view.getInt32(0, true);
    header.is8bit = view.getUint32(4, true) === 1;
    header.sampleRate = view.getInt32(8, true);
    header.scale = view.getInt32(12, true);
    header.numSamples = view.getUint32(16, true);
    return header;
  }
}

export default class Peaks {
  constructor(buffer) {
    this.view = new DataView(buffer);
    this.header = PeaksDataHeader.fromView(this.view);
    this.cache = {};
  }

  sampleAt(index) {
    return this.view.getInt8(20 + index);
  }

  getMinSample(offset) {
    return this.sampleAt(offset * 2);
  }

  getMaxSample(offset) {
    return this.sampleAt(offset * 2 + 1);
  }

  getSamples(width) {
    if (width <= 0) {
      throw new RangeError('Invalid width requested');
    }

    if (Array.isArray(this.cache[width])) {
      return this.cache[width];
    }

    const { header } = this;
    const { numSamples } = header;
    const data = [];

    let prevIndex = 0;
    let maxPeak = 0;

    for (let x = 0; x < width; x++) {
      const index = Math.floor((x / width) * numSamples);

      let min = MAX_PEAK_VALUE;
      let max = MIN_PEAK_VALUE;

      for (let i = prevIndex; i < index; i++) {
        const minSample = this.getMinSample(i);
        const maxSample = this.getMaxSample(i);

        if (minSample < min) {
          min = minSample;
        }
        if (maxSample > max) {
          max = maxSample;
        }
      }

      const peak = Math.abs(min) + Math.abs(max);
      if (peak > maxPeak && x > 0) {
        maxPeak = peak;
      }
      data.push(peak);

      prevIndex = index;
    }

    this.cache[width] = data.map((v) => v / maxPeak);

    return this.cache[width];
  }
}
